import { Note } from '../../../server/src/types/note';
import { NoteProps } from '../../note/note';
import { noteApi } from '../../services/api';

class NoteManager {
    private static instance: NoteManager;
    private notes: NoteProps[] = [];
    private initializationPromise: Promise<void>;
    private subscribers: (() => void)[] = [];

    private constructor() {
      this.initializationPromise = this.initializeNotes();
    } 

    private async initializeNotes(): Promise<void> {
      try {
        const notesFromServer = await noteApi.getAllNotes();
        this.notes = notesFromServer;
        console.log('from server')
        console.log(this.notes.length);
      } catch (error) {
        console.error('Failed to initialize notes:', error);
      }
    }
  
    // Get the single instance
    public static getInstance(): NoteManager {
      if (!NoteManager.instance) {
        NoteManager.instance = new NoteManager();
      }
      return NoteManager.instance;
    }

    public subscribe(callback: () => void): () => void {
      this.subscribers.push(callback);
      // Return unsubscribe function
      return () => {
          this.subscribers = this.subscribers.filter(listener => listener !== callback);
      };
    }

    private notifySubscribers() {
        this.subscribers.forEach(listener => listener());
    }
    
    // Get all todos
    public async getNotes(): Promise<NoteProps[]> {
      await this.initializationPromise;
      return this.notes;
    }
  
    // Add a todo
    public async addNote(note: NoteProps): Promise<void> {
      const createdNote = await noteApi.createNote(note);
      this.notes = [createdNote, ...this.notes];
      this.notifySubscribers();
    }
  
    // Delete a todo
    public async deleteNote(id: string): Promise<void> {
      await noteApi.deleteNote(id);
      this.notes = this.notes.filter(note => note._id !== id);
      this.notifySubscribers();
    }
  
    // Update a todo
    public async updateNote(updatedNote: NoteProps): Promise<void> {
      try {
            const updated = await noteApi.updateNote(
              updatedNote.id.toString(), 
              updatedNote
            );
            const index = this.notes.findIndex(todo => todo.id === updatedNote.id);
            if (index !== -1) {
              this.notes[index] = updated;
            }
            this.notifySubscribers();
          } catch (error) {
            console.error('Failed to update note:', error);
            throw error;
          }
    }

    public async updateNoteDate(updatedNote: NoteProps, date: Date): Promise<void> {
      try {
        const updated = await noteApi.updateNote(
          updatedNote._id, 
          { ...updatedNote, date: date });
        const index = this.notes.findIndex(note => note._id === updatedNote._id);
        if (index !== -1) {    
          this.notes[index] = updated;
        }
        this.notifySubscribers();
      } catch (error) {
        console.error('Failed to update note date:', error);
        throw error;
      }
    }

    public async updateNoteContent(updatedNote: NoteProps, content: string): Promise<void> {
      try {
        const updated = await noteApi.updateNote(
          updatedNote._id, 
          { ...updatedNote, content: content });
        const index = this.notes.findIndex(note => note._id === updatedNote._id);
        if (index !== -1) {    
          this.notes[index] = updated;
        }
        this.notifySubscribers();
      } catch (error) {
        console.error('Failed to update note content:', error);
        throw error;
      }
    }

    // public updateTodoComplete(updatedTodo: NoteProps, isCompleted: boolean) {
    //   const index = this.notes.findIndex(todo => todo.id === updatedTodo.id);
    //   if (index !== -1) {
    //     this.notes[index] = {
    //       ...this.notes[index],
    //       completed: isCompleted
    //     };
    //   }
    // }

    public async refreshTodos(): Promise<void> {
      try {
        const notesFromServer = await noteApi.getAllNotes();
        this.notes = notesFromServer;
      } catch (error) {
        console.error('Failed to refresh notes:', error);
        throw error;
      }
    }

    private readonly DRAFT_NOTE_KEY = 'draft_note';

    // Save draft note to localStorage
    public saveDraftNote(note: Note): void {
      try {
        localStorage.setItem(this.DRAFT_NOTE_KEY, JSON.stringify(note));
      } catch (error) {
        console.error('Failed to save draft note:', error);
      }
    }

    // Get draft note from localStorage
    public getDraftNote(): Note {
      try {
        const draftNote = localStorage.getItem(this.DRAFT_NOTE_KEY);
        console.log("Retrieved from localStorage:", draftNote);
        
        if (draftNote !== null && draftNote !== undefined) {
          console.log("draftNote exists");
          const parsed = JSON.parse(draftNote);
          // Convert date string back to Date object
          return {
            ...parsed,
            date: new Date(parsed.date)
          };
        }
      } catch (error) {
        console.error('Failed to get draft note:', error);
      }
      
      // Default note if nothing in localStorage or if there was an error
      return {
        id: Date.now(),
        title: "",
        date: new Date(),
        content: "",
      };
    }

    // Clear draft note from localStorage
    public clearDraftNote(): void {
      try {
        localStorage.removeItem(this.DRAFT_NOTE_KEY);
      } catch (error) {
        console.error('Failed to clear draft note:', error);
      }
    }
}
  
export default NoteManager;